import posthog from 'posthog-js/dist/module.full'

const config = window.posthogConfig || {
  disableSessionRecording: false,
  sessionRecording: {
    maskAllInputs: false,
    maskAllText: false,
    captureNetworkRequests: true,
    recordCanvas: true
  }
};

const posthogConfig = {
  api_host: 'https://eu.i.posthog.com',
  disable_session_recording: config.disableSessionRecording,
  loaded: (posthog) => {
    posthog.register({ environment: __AWS_ENV__ });
    
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      const status = config.disableSessionRecording 
        ? 'session recording disabled (mobile)'
        : config.sessionRecording?.recordCanvas === false
          ? 'canvas recording disabled' 
          : 'full recording enabled';
      console.log(`PostHog initialized (${status}, environment: ${__AWS_ENV__})`);
    }
  }
};

if (!config.disableSessionRecording && config.sessionRecording) {
  posthogConfig.session_recording = config.sessionRecording;
}

posthog.init('phc_RV5tHrUxr1iD3MPUQC1iOkaXfxopkj6K1G2UZGq8DcJ', posthogConfig);

window.posthog = posthog;

// Unified, safe client-side capture helper. Mirrors the backend track_posthog_event
// convention: keep event names snake_case + past tense, and pass feature/action in
// props when a cross-source breakdown is needed. No-ops if PostHog is unavailable.
window.phCapture = function (event, props) {
  try {
    if (!event || !window.posthog || typeof window.posthog.capture !== 'function') return;
    window.posthog.capture(event, props || {});
  } catch (e) {
    // Never let analytics break the UI.
  }
};

// Delegated capture for simple declarative usage without a Stimulus controller:
//   <a data-ph-capture="quicklink_clicked" data-ph-target="drive">...</a>
// Any data-ph-* attribute (except data-ph-capture) becomes a property.
document.addEventListener('click', (e) => {
  const el = e.target.closest('[data-ph-capture]');
  if (!el) return;
  const event = el.dataset.phCapture;
  if (!event) return;
  const props = {};
  for (const key in el.dataset) {
    if (key === 'phCapture' || !key.startsWith('ph')) continue;
    // dataset key "phTarget" -> property "target"
    const prop = key.slice(2);
    props[prop.charAt(0).toLowerCase() + prop.slice(1)] = el.dataset[key];
  }
  window.phCapture(event, props);
});

// Turbo: after each visit the new HTML is in the DOM; re-apply register + identify (Hotwire turbo:load).
// https://github.com/hotwired/turbo — fires when the page has fully loaded (initial + Drive navigations).
document.addEventListener('turbo:load', () => {
  if (typeof window.syncPosthogUserContext === 'function') {
    window.syncPosthogUserContext();
  }
});
